/** 
 * Import Ionic and others
 */
import { Component, ViewChild } from '@angular/core';
import { Platform, Events, ToastController, MenuController, Nav, NavController } from 'ionic-angular';
import { StatusBar, Splashscreen, GoogleAnalytics } from 'ionic-native';
import { Deeplinks } from '@ionic-native/deeplinks';

/**
 * Import Pages
 */
import { TutorialPage } from '../pages/tutorial/tutorial';
import { HomePage } from '../pages/home/home';
import { PublicPage } from '../pages/public/public';
import { AccountSignupPage } from '../pages/account-signup/account-signup';
import { AccountLoginPage } from '../pages/account-login/account-login';


/**
 * Import Providers
 */
import { User } from '../providers/user';
import { Admob } from '../providers/admob';

const ROOT_PAGE: any = HomePage;
declare var window;


/**
 * 
 * 
 * @export
 * @class FiretaskApp
 */
@Component({
    selector: 'app',
    templateUrl: 'app.html'
})
export class FiretaskApp {
    // the root nav is a child of the root app component
    // @ViewChild(Nav) gets a reference to the app's root nav
    @ViewChild(Nav) nav: Nav;

    rootPage: any = ROOT_PAGE;
    connected: boolean = true;

    constructor(
        public platform: Platform,
        public admob: Admob,
        public user: User,
        public events: Events,
        public toast: ToastController,
        private deeplinks: Deeplinks,
        public menu: MenuController) {

        // handle presence
        this.user.presence();

        // handle events
        this.eventsHandler();

        // init device platform
        this.platformReady()
        
        // this.platform.ready().then(() => {
        //           // google
        //     GoogleAnalytics.debugMode()
        //     GoogleAnalytics.startTrackerWithId("UA-80942455-3");
        //     GoogleAnalytics.enableUncaughtExceptionReporting(true)
        //         .then((_success) => {
        //             debugger;
        //             console.log(_success)
        //         }).catch((_error) => {
        //             debugger;
        //             console.log(_error)
        //         })
        // });
    }

    eventsHandler() {
        //
        // User Logged In Event
        //
        this.events.subscribe('user:loggedIn', () => {
            console.info('user:loggedIn');
            let user = this.user.profile();
            //const toast = this.toast.create({
                //message: 'Hello ' + (user.displayName != null ? user.displayName : ''),
                //showCloseButton: true,
                //closeButtonText: 'Ok',
                //duration: 10000
            //});

            //
            // Show toast and goto Tasks
            //
            //toast.present().then(() => {
            //    this.user.accounting();
            //    this.nav.setRoot(HomePage);
            //});
        });

        //
        // User Logged Out Event
        //
        this.events.subscribe('user:loggedOut', () => {
            console.log('user:loggedOut');
            this.nav.setRoot(ROOT_PAGE);
        });

        //
        // User Offline Event
        //
        /*this.events.subscribe('user:offline', () => {
            const toast = this.toast.create({
                message: 'You are offline.',
                showCloseButton: true,
                closeButtonText: 'Ok',
                duration: 4000
            });

            if (this.connected) toast.present();
            this.connected = false;
        });*/

        //
        // User Online Event
        //
        /*this.events.subscribe('user:online', () => {
            console.info('user:online');
            const toast = this.toast.create({
                message: 'You are online.',
                showCloseButton: true,
                closeButtonText: 'Ok',
                duration: 4000
            });
            if (!this.connected) toast.present();
            this.connected = true;
        });*/

    }

    platformReady() {
        this.platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            // StatusBar.backgroundColorByHexString('#FFBD3D');
            // call admob
            // this.admob.ready();

            // Persist user gcm token      
            this.user.gcmToken();

            // hides splash
            Splashscreen.hide();
            StatusBar.hide();
            //if(window.cordova && window.cordova.plugins.Keyboard) {
                //cordova.plugins.Keyboard.hideKeyboardAccessoryBar(true);
                //cordova.plugins.Keyboard.disableScroll(true);
            //}
            //if(window.StatusBar) {
            //    org.apache.cordova.statusbar required
            //    StatusBar.styleDefault();
            //}
            /*if (window.StatusBar) {
                if (ionic.Platform.isAndroid()) {
                    StatusBar.backgroundColorByHexString("#608628");
                } else {
                    StatusBar.styleLightContent();
                }
            }*/

            // Convenience to route with a given nav (Nur für PWA oder Native)
            this.deeplinks.routeWithNavController(this.nav, {
                    '/home': HomePage,
                    '/products/:productId': HomePage
            }).subscribe((match) => {
                    console.log('Successfully routed', match);
            }, (nomatch) => {
                    console.warn('Unmatched Route', nomatch);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts